
                import "css-modules://src_components_arrow"
                export default {"Main":"_da011b","Flipped":"_42b7ec"}
            